// Total words the app lists across public/vocab-data/n1-n5.json: every entry in the
// files (7,749 after the NIH-281 rebuild, N5 763, N4 690, N3 1,593, N2 1,723, N1 2,980)
// minus any N5/N4 entry hidden by hiddenVocabulary.ts (NIH-282; none today). Kept as a
// constant so the homepage progress bar doesn't have to download every level's word
// list just to count them - vocabularyTotal.test.ts fails if the data files or the
// hidden list drift.
export const VOCABULARY_TOTAL = 7749;
